import useMediaQuery from '@/hooks/useMediaQuery';
import { cn } from '@/lib/utils';
import { useTheme } from 'next-themes';
import { useMemo } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const isDarkMode = useMemo(() => {
    return theme === 'dark' || (theme === 'system' && prefersDarkMode);
  }, [theme, prefersDarkMode]);

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className={cn('toaster group', isDarkMode && 'dark')}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
